import React from 'react';
import PropTypes from 'prop-types';

import {labels} from '../../../../../util/utils';

import {IconoirCustomContactList} from '@ey-xd/motif-icon';

import Module from '..';

const ContactListModule = ({onClick}) => {
	const props = {
		icon: IconoirCustomContactList,
		label: labels.contactList,
		onClick
	};

	return <Module {...props} />;
};

ContactListModule.propTypes = {};

ContactListModule.defaultProps = {};

export default ContactListModule;
